import React from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core';
import { withRouter } from 'react-router';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { SelectorContext }  from '../../../context';

const useStyles = makeStyles(theme => ({
    formControl: {
        marginBottom: theme.spacing(2),
        width: '100%',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    ButtonWrapper: { },
    BtnSubmit : {
        width: '100%',
        height: '48px'
    },    
    Horizontal : {
        display: 'flex', 
        flexWrap: 'wrap',  
        marginBottom: theme.spacing(5),     
        '& $formControl': {
            width: '300px',
            marginRight: theme.spacing(2)
        },
        '& $ButtonWrapper' : {
            display: 'flex',
            width: '100%'
        },
        '& $BtnSubmit': {          
            width: 'auto'            
        }
    },
    dropdownStyle : {
        background: '#fff'
    }
}));

function ConfigSelector(props) {
    const classes = useStyles();
    let [rubro, setRubro] = React.useState('');
    let [marcas, setMarcas] = React.useState([]);
    let [modelos, setModelos] = React.useState([]);    
    let [marcasOptions, setMarcasOptions] = React.useState([]);
    let [modelosOptions, setModelosOptions] = React.useState([]);    
    const selectorCtx = React.useContext(SelectorContext);    

    const inputLabelRubro = React.useRef(null);    
    
    const [labelRubroWidth, setLabelRubroWidth] = React.useState(0);
    
    React.useEffect(() => {
        if (rubro !== '') {
            fetch(`https://www.agroads.com.ar/precios/api/es.asp?action=consultaMarcas&maquinaria=${rubro}`)
                .then(res => res.json())
                .then(resJson => {                                            
                    fillMarcasOptions(resJson.filter(elem => elem.marca_id.buckets[0].modelo.buckets.length > 0), setMarcasOptions, 'marca_id')                    
                })
                .catch(error => console.log(error))
        }
        else {
            setMarcas([]);
            setMarcasOptions([]);
            setModelos([]);
        }
        
    }, [rubro])

    React.useEffect(() => {
            setModelos(modelos.filter(mod => marcas.find(marca => mod.marca === marca.name)));            
            if (rubro !== '' && marcas.length > 0) {
                fetch(`https://www.agroads.com.ar/precios/api/es.asp?action=consultaModelos&maquinaria=${rubro}&id_marca=${marcas.map( m => m.id).join(',')}`)
                    .then(res => res.json())
                    .then(resJson => {                                    
                        fillModelosOptions(resJson);                    
                    })
                    .catch(error => console.log(error))
            }
            else {
                setModelosOptions([]);
                setModelos([]);
            }
    }, [marcas])
    

    React.useEffect(() => {
        setLabelRubroWidth(inputLabelRubro.current.offsetWidth);
        if (selectorCtx.rubro > 0) {
            setRubro(selectorCtx.rubro);
        } 
        else {
            if (props.match.params.rubro2) {
                setRubro(props.match.params.rubro2)
                selectorCtx.rubro = parseInt(props.match.params.rubro2)
            }
        }
        if (selectorCtx.marca.length > 0) {
            setMarcas(selectorCtx.marca.map(marca => marca));
        }

        if (selectorCtx.modelo.length > 0) {
            setModelos([...selectorCtx.modelo.map(mod => mod)]);
        } else {
            if (props.match.params.rubro2 && props.match.params.modelosParams && props.match.params.modelosParams !== '') {
                fetch(`https://www.agroads.com.ar/precios/api/es.asp?action=dataModelos&maquinaria=${props.match.params.rubro2}&id_modelo=${props.match.params.modelosParams}`)
                    .then(res => res.json())
                    .then(jsonRes => {
                        let marcas = [], modelos = []
                        jsonRes.forEach(item => {
                            let marcaAux = { id: item.marca_id.buckets[0].key, name: item.key }
                            item.marca_id.buckets[0].modelo.buckets.forEach(bucket => {
                                let modeloAux = { marca: item.key, id: bucket.modelo_id.buckets[0].key, name: bucket.key }
                                modelos.push(modeloAux);
                            })
                            marcas.push(marcaAux)
                        });                        
                        selectorCtx.marca = [...marcas]
                        selectorCtx.modelo = [...modelos]    
                        
                        setModelos(modelos.map(mod => mod));   
                        setMarcas(marcas.map(m => m))                 
                    })                
            }
        }
    }, []);

    const handleChangeRubro = (event) => {
        setRubro(event.target.value);       
        selectorCtx.rubro = event.target.value; 
        setMarcas([]);
        setModelos([]);
    };
    const handleChangeMarca = (event, value) => {                           
        if (value.length <=3) {
            setMarcas(value.map(marca => marca));
            selectorCtx.marca = [...value.map(marca => marca)];             
            
            // sacar modelos que no esten en array value
            if (selectorCtx.modelo && selectorCtx.modelo.length > 0)
            {
                selectorCtx.modelo = selectorCtx.modelo.filter(mod => value.every(marca => marca.name === mod.marca))
            }
        }
    };
    const handleChangeModelo = (event, value) => {     
        if (value.length <= 3) {            
            setModelos(value.map(modelo => modelo));
            selectorCtx.modelo = [...value.map(modelo => modelo)];
        }   
    };    

    const handleSubmit = event => {                            
        props.history.push(`/r/${rubro}/modelos/${modelos.map(m => m.id).join(',')}/`)
    }

    const fillMarcasOptions = (collection) => {              
        let optionsAux = collection.map(elem => {           
                return { id: elem.marca_id.buckets[0].key, name: elem.key}                             
        })
        setMarcasOptions(optionsAux);
    }

    const fillModelosOptions = (collection) => {        
        let optionsAux = []
        collection.forEach(elem => {
            elem.modelo.buckets.forEach(bucket => {
                optionsAux.push({ marca: elem.key, id: bucket.modelo_id.buckets[0].key, name: bucket.key })
            });
        });        
        setModelosOptions(optionsAux);
        selectorCtx.modelosOptions = [...optionsAux];        
    }

    return (
        <div className={props.type === 'horizontal' ? classes.Horizontal : null }>
                <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel ref={inputLabelRubro} id="label-rubro">
                        Seleccioná el rubro principal
                    </InputLabel>
                    <Select
                        labelId="label-rubro"                    
                        value={rubro}
                        onChange={handleChangeRubro}    
                        labelWidth={labelRubroWidth}
                        MenuProps={{ classes: { paper: classes.dropdownStyle }}}
                    >
                        <MenuItem key="rubro-not-selected" value="">
                            <em>No seleccionado</em>
                        </MenuItem>
                        <MenuItem value={10}>Tractores</MenuItem>
                        <MenuItem value={11}>Cosechadoras</MenuItem>
                        <MenuItem value={12}>Sembradoras</MenuItem>
                        <MenuItem value={13}>Pulverizadoras</MenuItem>
                    </Select>
                </FormControl>  
                <FormControl className={classes.formControl}>
                    <Autocomplete
                        multiple      
                        blurOnSelect={true}                  
                        id="marcas-select"
                        options={marcasOptions}
                        getOptionLabel={option => option.name}
                        onChange={handleChangeMarca}     
                        getOptionSelected={(option, value) => {
                            return option.id === value.id
                        }}
                        classes={{ paper: classes.dropdownStyle }}
                        noOptionsText="Sin opciones"
                        value={marcas}                        
                        renderInput={params => (
                            <TextField
                            {...params}
                                variant="outlined"
                                label="Elegí las marcas"
                                fullWidth                                
                            />
                        )}
                    />
                    {marcas.length === 0 || marcas.length === 3 ?
                    <FormHelperText>Hasta 3 marcas como máximo</FormHelperText>
                    : null}                    
                </FormControl>
                <FormControl className={classes.formControl}>
                    <Autocomplete
                        multiple                        
                        id="modelos-select"   
                        blurOnSelect={true}                                               
                        options={modelosOptions.sort((a, b) => -b.marca.localeCompare(a.marca))}
                        groupBy={option => option.marca}
                        getOptionLabel={option => option.name}                        
                        getOptionSelected={(option, value) => {                            
                            return option.id === value.id
                        }}
                        classes={{ paper: classes.dropdownStyle }}
                        noOptionsText="Sin opciones"
                        value={modelos}
                        onChange={handleChangeModelo}                        
                        disableCloseOnSelect                 
                        renderInput={params => (
                            <TextField
                                {...params}
                                variant="outlined"
                                label="Elegí los modelos"                                
                                fullWidth
                            />
                        )}
                    />
                    { modelos.length === 0 || modelos.length === 3 ? 
                    <FormHelperText>Hasta 3 modelos como máximo</FormHelperText>
                    : null }
                </FormControl>

                
                <div className={classes.ButtonWrapper}>
                    <Button variant="contained" color="primary" className={classes.BtnSubmit} disabled={rubro === '' || marcas.length === 0 || modelos.length === 0} onClick={handleSubmit}>Ver precios</Button>
                </div>            
        </div>                     
    )
}

export default withRouter(ConfigSelector);
